import { useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Stack,
  Box,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import { AuthLayout } from "../../layouts";
import SigninTextInput from "../../components/SigninTextInput";
import { CustomButton, CustomLoader } from "../../components";
import { capitalizeFirstLetter } from "../../utils/strings";
import i18n from "../../i18n-config";
import theme from "../../theme/theme";
import SigninHeader from "./components/SigninHeader";
import { LockICON } from "../../assets/icons";
import { asyncSignin } from "../../store/features/authSlice";

const Signin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [credentials, setCredentials] = useState({
    telephone: "",
    pin: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [badCredentials, setBadCredentials] = useState(false);

  const callback = () => {
    setIsLoading(false);
    navigate("/");
  };

  const onError = () => {
    setIsLoading(false);
  };
  const badCredentialsError = () => {
    setIsLoading(false);
    setBadCredentials(true);
  };

  const toggleLoader = () => {
    setIsLoading(!isLoading);
  };

  const onChangeCredentials = (key: string, value: string) => {
    setCredentials({
      ...credentials,
      [key]: value,
    });
  };

  const onSubmit = async (event: any) => {
    try {
      event.preventDefault();
      setIsLoading(true);

      setBadCredentials(false);

      dispatch(
        asyncSignin(
          credentials,
          callback,
          badCredentialsError,
          onError
        ) as never
      );

    } catch (error) {
      // showError(capitalizeFirstLetter(i18n.t("error_occured")), {
      //   horizontal: "right",
      //   vertical: "bottom",
      // });
      setIsLoading(false);
      // dispatch(authIsLoaded(false));
      console.log(error);
    }
  };

  const disabled = !credentials.telephone?.trim() || !credentials.pin?.trim();

  const handleForgotPassword = () => {
      navigate("/forgot-password");
  };

  return (
    <AuthLayout
      onSubmit={onSubmit}
      leftComponent={
        <Card
          sx={{
            maxWidth: { xs: "100%", md: 450, lg: 450 },
            boxShadow: "none",
            maxHeight: 650,
          }}
        >
          <CardContent>
            <Box
              sx={{
                width: "100%",
              }}
              mt={3}
            >
              <SigninHeader
                title={`${i18n.t("bonjour")} !`}
                subTitle="Lorem ipsum sit amet dolor consectur adisciping elit"
              />
              <SigninTextInput
                title={capitalizeFirstLetter(i18n.t("votre_email"))}
                value={credentials.telephone}
                onChange={(text: string) =>
                  onChangeCredentials("telephone", text)
                }
              />
              <SigninTextInput
                title={capitalizeFirstLetter(i18n.t("motdepasse"))}
                value={credentials.pin}
                onChange={(text: string) => onChangeCredentials("pin", text)}
                type="password"
                endIcon={<LockICON />}
              />

              {badCredentials ? (
                <Typography color={theme.colors.red} fontSize={12} mb={2}>
                  {i18n.t("invalid_password")}
                </Typography>
              ) : null}

              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label={i18n.t("se_souvenir_moi")}
              />

              <Stack direction={"row"} mt={2}>
                <CustomButton
                  title={capitalizeFirstLetter(i18n.t("se_connecter"))}
                  onClick={onSubmit}
                  disabled={disabled}
                  rootStyle={{
                    width: "100%",
                    borderRadius: 50,
                  }}
                  titleStyle={{ color: theme.colors.white }}
                />

                <CustomButton
                  title={capitalizeFirstLetter(i18n.t("motdepasse_oublie"))}
                  onClick={handleForgotPassword}
                  titleStyle={{ color: theme.colors.black, fontSize: 12 }}
                  rootStyle={{
                    backgroundColor: "transparent",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Stack>
            </Box>
            <Typography
              color="#B5BAB5"
              sx={{ position: "absolute", bottom: 50, left: 230 }}
            >
              2023 Jevebara Inc.
            </Typography>
            <CustomLoader open={isLoading} handleClose={toggleLoader} />
          </CardContent>
        </Card>
      }
    />
  );
};

export default Signin;
